export default __webpack_public_path__ + "static/media/kwitter.cfed8fe8.png";